import React from 'react'
import { Link } from 'react-router-dom'
import { pathOr } from 'ramda'
import Type from '../Type'
import L from '../L'
import { PRODUCTION } from '../../Config'
import { StyledCollectionCard, CollectionDot, CollectionTitle, StyledCollectionGrid } from './CollectionCard-styles'

const CollectionCard = props => (
  <StyledCollectionCard {...props}>
    <CollectionDot {...props} />
    <L display="grid" gap={0.5} pX={2} pY={2} position="absolute" b="0" l="0" color="inverted">
      <div>
        <CollectionTitle>{props.cardTitle}</CollectionTitle>
      </div>
      {props.subtitle && <Type variant="subtitle">{props.subtitle}</Type>}
    </L>
  </StyledCollectionCard>
)

const CollectionGrid = ({ collections, simulations, type, baseUrl }) => {
  const row = []
  Object.keys(collections).map(collectionKey => {
    const collection = collections[collectionKey]

    if (collection.type === type) {
      let totalSims = 0
      for (let i = 0; i < collection.simulations.length; i++) {
        const sim = simulations[collection.simulations[i]]
        if (sim) {
          if (PRODUCTION ? !sim.hasOwnProperty('hideProd') : true) totalSims++
        }
      }
      if (totalSims > 0) {
        row.push(
          <Link key={`collection_${type}_${collection.id}`} to={`${baseUrl}${collection.id}`}>
            <CollectionCard
              bgImg={pathOr('', ['thumbnail', 'signedUrl'], collection)}
              cardTitle={collection.name}
              // subtitle={collection.name}
              totalSims={totalSims}
            />
          </Link>,
        )
      }
    }
  })
  return <StyledCollectionGrid>{row}</StyledCollectionGrid>
}

export default CollectionGrid
